import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { IExportProjectStatsBl } from '../ExportProjectStats.bl';
import { ExportProjectStatsButton } from './ExportProjectStatsButton';

export const ExportProjectStatsButtonContainer = observer((): ReactElement => {
  const bl = useInjection(IExportProjectStatsBl.$);

  const handleExportStats = async (): Promise<void> => {
    await bl.exportStatsAsync();
  };

  return <ExportProjectStatsButton onClickExportButton={handleExportStats} />;
});
